import { GetB2bAdminsShowResponse } from '@Common/types/bo/b2b/admins';
import { GetLoginLinkResponse } from '@Common/types/bo_external/auth/magic_link';

export const b2bAdminsTranslations = {
  title: 'Admins B2B',
  fields: {
    id: 'Admin ID',
    email: 'Email',
    email_state: 'Statut de l’e-mail',
    status: 'Statut',
    created_at: 'Créé le',
    updated_at: 'Mis à jour à',
    company_id: 'ID Entreprise',
    company_name: 'Nom Entreprise',
    role_in_company: "Fonction dans l'entreprise",
    firstname: 'Prénom',
    lastname: 'Nom',
    phone_number: 'Téléphone',
    secondary_email: '2e e-mail pour l’authentification à deux facteurs',
    secondary_email_state: 'Statut du 2e e-mail',
    last_invitation_sent_at: 'Dernière invitation envoyée à',
    has_last_otp: 'Dernier OTP valide',
    ghost_login: 'Login fantôme',
    is_migrated: 'Est migré depuis AXA',
    email_verified: 'Email vérifié',
    role: 'Habilitation',
    language_preference: 'Langue de préférence',
    is_third_party: 'Est un correspondant externe',
    third_party_legal_structure: 'Forme juridique',
    third_party_mandate_document_id: 'Document de mandat',
    gender: 'Civilité',
    is_mailing_correspondent: 'Correspondant courrier ?',
    mailing_street: 'Rue',
    mailing_postalcode: 'Code postal',
    mailing_city: 'Ville',
    mailing_country: 'Pays',
    is_npai_mailing: 'Adresse courrier PND ?',
    npai_mailing_at: 'PND le',
    is_billing_correspondent: 'Correspondant facturation ?',
    billing_channel: 'Canal de facturation',
    billing_street: 'Rue',
    billing_postalcode: 'Code postal',
    billing_city: 'Ville',
    billing_country: 'Pays',
    is_npai_billing: 'Adresse de facturation PND ?',
    npai_billing_at: 'PND le',
  } satisfies Record<keyof GetB2bAdminsShowResponse | 'ghost_login' | 'company_name', string>,
  sections: {
    third_party: 'Correspondant externe',
    mailing_address: 'Adresse de courrier',
    billing_address: 'Adresse de facturation',
  },
  choices: {
    status: {
      active: 'Actif',
      inactive: 'Inactif',
      pending: 'En attente',
      invited: 'Invité',
    },
    billing_channel: {
      paper: 'Papier',
      email: 'E-mail',
      both: 'Papier et e-mail',
    },
  },
  steps: {
    general: 'Informations générales',
    addresses: 'Adresses',
    confirmation: 'Confirmation',
  },
  correspondence: {
    mailing_title: 'Adresse de courrier du correspondant',
    billing_title: 'Adresse de facturation du correspondant',
    company_address_fallback: "Laisser vide pour utiliser l'adresse de l'entreprise",
    company_address_used: "L'adresse de l'entreprise est utilisée",
    yes: 'Oui',
    no: 'Non',
  },
  button: 'Créer un correspondant',
  empty: "Cette entreprise n'a pas encore de correspondant",
  actions: {
    create: {
      title: 'Créer un correspondant entreprise',
      success: 'Correspondant entreprise créé',
      failure: 'La création du correspondant entreprise à échouée: %{error}',
    },
    edit: {
      title: 'Éditer le correspondant entreprise',
      success: 'Correspondant entreprise mis à jour',
      failure: 'La mise à jour du correspondant entreprise à échouée: %{error}',
      validation: {
        email_same_as_secondary_email:
          'L’adresse e-mail principale et l’adresse e-mail secondaire ne peuvent pas être identiques',
      },
    },
    delete: {
      title: "Supprimer l'administrateur B2B ?",
      content:
        "Vous êtes sur le point de supprimer un administrateur B2B dont l'ID est %{adminId} et l'adresse e-mail %{email}.",
    },
    request_otp: {
      label: 'Demander un OTP',
      dialog: {
        title: 'OTP demandé',
        description:
          'Fournissez ce code OTP au client pour lui permettre de réinitialiser son mot de passe.',
      },
    },
    last_otp: {
      show: 'Afficher le dernier OTP valide',
      hide: 'Masquer le dernier OTP valide',
      no_last_otp: 'Aucun dernier OTP valide',
    },
    send_invite: {
      label: 'Envoyer une invitation |||| Envoyer des invitations',
      dialog: {
        title: 'Confirmation',
        confirm:
          'Êtes-vous sûr de vouloir envoyer une invitation au correspondant ? |||| Êtes-vous sûr de vouloir envoyer des invitations aux correspondants sélectionnés ?',
        success: 'Invitation envoyée',
        failure: 'Échec de l’envoi de l’invitation : \n%{error}',
      },
    },
  },
  notifications: {
    last_otp_fetch_error: 'Impossible de récupérer le dernier OTP',
    last_otp_unavailable: 'Impossible de récupérer le code, il a expiré ou a déjà été utilisé',
  },
  login_link: {
    fields: {
      id: 'ID Lien',
      url: 'Login fantôme',
    } satisfies Record<keyof GetLoginLinkResponse, string>,
    tooltip: {
      not_activated: "L'utilisateur doit être activé pour que le login fantôme soit disponible",
    },
  },
  third_party_disclaimer:
    "En accordant l'accès à cet espace web à un utilisateur externe, vous confirmez avoir vérifié son identité et acceptez qu'il puisse consulter les données et fonctionnalités selon les droits attribués. Vous êtes responsable du niveau d'accès accordé et devez le révoquer dès qu'il n'est plus nécessaire.",
};
